var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { computePosition, shift, flip } from "@floating-ui/dom";
let QboPopover = class QboPopover extends LitElement {
    constructor() {
        super(...arguments);
        this.placement = "bottom";
        this.selector = '*[data-popover-trigger]';
        // Internal state to control menu visibility
        this.isOpen = false;
        this.middleware = [flip(), shift()];
        this.handleMenuOpen = (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (event.detail.menu !== this && this.isOpen)
                this.closeMenu();
        };
        this.toggleMenu = (event) => {
            this.isOpen = !this.isOpen;
            this.classList.toggle("open", this.isOpen);
            if (this.isOpen) {
                this.setPosition();
                document.dispatchEvent(new CustomEvent("qbo-popover-open", {
                    bubbles: true,
                    composed: true,
                    detail: { menu: this },
                }));
            }
        };
    }
    async setPosition() {
        const { x, y } = await computePosition(this.triggerElement, this, {
            placement: this.placement,
            middleware: this.middleware,
        });
        Object.assign(this.style, {
            left: `${x}px`,
            top: `${y}px`,
        });
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("qbo-popover-open", this.handleMenuOpen);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("qbo-popover-open", this.handleMenuOpen);
        if (this.triggerElement != null) {
            this.triggerElement.removeEventListener("mouseover", this.toggleMenu);
            this.triggerElement.removeEventListener("mouseout", this.toggleMenu);
        }
    }
    firstUpdated(changes) {
        super.firstUpdated(changes);
        this.triggerElement =
            this.parentElement?.querySelector(this.selector) ||
                this.shadowRoot?.querySelector(this.selector) ||
                document.querySelector(this.selector) ||
                this.parentElement;
        if (this.triggerElement != null) {
            this.triggerElement.addEventListener("mouseover", this.toggleMenu);
            this.triggerElement.addEventListener("mouseout", this.toggleMenu);
        }
    }
    closeMenu() {
        this.isOpen = false;
        this.classList.remove("open");
    }
    render() {
        return html `<slot></slot>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], QboPopover.prototype, "placement", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboPopover.prototype, "selector", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], QboPopover.prototype, "isOpen", void 0);
QboPopover = __decorate([
    customElement('qbo-popover')
], QboPopover);
export { QboPopover };
